import React, { useState, useEffect, useRef } from 'react'
import Header from '../layout/header'
import BannerImg from "../assets/images/admin-banner.webp"
import { FiSearch } from "react-icons/fi";
import { ToastContainer, toast } from 'react-toastify';
import { GoTrash } from "react-icons/go";
import { FaRegEdit } from "react-icons/fa";
import { apiCallingPost } from "../api/services"
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import TagDirectoryEdit from './tag-directory-edit';
import TagDirectoryDelete from './Tag-directory-delete';
import { setTagList } from '../redux/reducers/commonSlice';
import { MdFindReplace } from 'react-icons/md';

function TagDirectory() {
  const [mediaListFlag, setMediaListFlag] = useState(false)
  const [tagDirectoryList, setTagDirectoryList] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [activeLetters, setActiveLetters] = useState(["All"]);
  const [filteredTags, setFilteredTags] = useState([]);
  const [tagPopup, setTagPopup] = useState(false)
  const [updateTag, setUpdateTag] = useState("");
  const [selectTagList, setSelectTagList] = useState([]);
  const wrapperRef = useRef(null);
  const letters = ["All", ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];
  const [tagDeletePopup, setTagDeletePopup] = useState(false)
  const [videoDetails, setVideoDetails] = useState([])
  const [findTagFlag, setFindTagFlag] = useState(false);
  const [findTag, setFindTag] = useState("");

  useEffect(() => {
    TagDirectoryList()
    const handleEvents = (event) => {
      if (event.type === 'keydown' && event.key === 'Escape') {
        cancelPopup();
      }
      if (
        event.type === 'mousedown' &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        cancelPopup();
      }
    };

    document.addEventListener('keydown', handleEvents);
    document.addEventListener('mousedown', handleEvents);

    return () => {
      document.removeEventListener('keydown', handleEvents);
      document.removeEventListener('mousedown', handleEvents);
    };
  }, [])

  useEffect(() => {
    filterTagList();
  }, [tagDirectoryList, searchText, activeLetters]);

  const TagDirectoryList = async () => {
    setLoading(true)
    let postData = {
      searchText: ""
    }
    try {
      const response = await apiCallingPost("api/tag_directory/get_tags", postData);
      const { data } = response;
      if (data.success === "1") {
        setTagDirectoryList(data.result.tags)
      }
      else {
        setTagDirectoryList([])
      }
    } catch (error) {
      console.error("Error fetching tag update directory:", error);

    } finally {
      setLoading(false)
    }
  }

  const handleLetterClick = (letter) => {
    setSearchText("")
    if (letter === "All") {
      if (activeLetters.includes("All")) {
        setActiveLetters([]);
      } else {
        setActiveLetters(["All"]);
      }
    } else {
      let updated = [...activeLetters];
      updated = updated.filter(list => list !== "All");

      if (updated.includes(letter)) {
        updated = updated.filter(list => list !== letter);
      } else {
        updated.push(letter);
      }
      if (updated.length === 0) {
        updated = ["All"];
      }
      setActiveLetters(updated);
    }
  };

  const filterTagList = () => {
    const letters = activeLetters.includes('All') ? [] : activeLetters;
    let filtered, matchesSearch, matchesLetter;
    if (searchText) {
      if (!activeLetters.includes("All")) {
        setActiveLetters(["All"]);
      }
      filtered = tagDirectoryList.filter(tag => {
        const tagText = tag.toLowerCase();
        matchesSearch = tagText.startsWith(searchText.toLowerCase());
        return matchesSearch;
      });
    } else {
      filtered = tagDirectoryList.filter(tag => {
        const tagText = tag.toLowerCase();
        matchesLetter = letters.length === 0 || letters.some(letter =>
          tagText.trim().charAt(0).toLowerCase() === letter.toLowerCase()
        );
        return matchesLetter;
      });
    }
    setFilteredTags(filtered);
  };

  const cancelPopup = () => {
    setTagPopup(false)
    setTagDeletePopup(false)
    setFindTagFlag(false)
    setUpdateTag("")
    setFindTag("")
    setVideoDetails([])
  }

  const TagVideoDetails = async (tagNames) => {
    
    let postData = {
      tag_name: tagNames
    }
   
    try {
      const response = await apiCallingPost("api/tag_directory/get_video_by_tag", postData);
      const { data } = response;
      
      if (data.success === "1") {
        setVideoDetails(data.result);
      }
      else {
        setVideoDetails([])
      }
    } catch (error) {
      console.error("Error fetching  Tag video details:", error);

    }
  }

  const selectIds = (tagName) => {
    setSelectTagList((prev) => {
      if (prev.includes(tagName)) {
        return prev.filter(tag => tag !== tagName)
      } else {
        return [...prev, tagName]
      }
    })
  }

  return (
    <div className='home-wrapper main-wrapper  main-wrapper-cms video-list'>
      <ToastContainer />
      <Header setMediaListFlag={setMediaListFlag} mediaListFlag={mediaListFlag} />
      <div className=' banner-admin'>
        <div className='banner-admin-div'>
          <img className='img-fluid banner-admin-img' src={BannerImg} alt='Banner image' width={"100%"} height={500} />
        </div>
        <div className='search-wrapper'>
          <div className='container'>
            <div className='search-sub-wrap'>
              <div className="d-flex w-100 justify-content-end gap-10">
                <div className='banner-title-admin'>
                  Tag Directory
                </div>
                <div className='search-section'
                  style={{ minWidth: '50%' }}
                >
                  <div className='search-div'>
                    <input type='text' className='search-input' placeholder='Tag Directory Search'
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)} />
                  </div>

                </div>
                <div className='search-section d-flex  pe-1 pe-lg-0 from-date-search'>
                  <FiSearch className='search-video-list' />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="container my-3 my-md-5">
        <div className='tag-listing-filter-outer'>
          <div className='tag-listing-filter'>
            {letters.map((letter, index) => (
              <div
                key={index}
                className={`tag-listing-inner-filter ${activeLetters.includes(letter) ? 'active' : ''}`}
                onClick={() => handleLetterClick(letter)}
              >
                {letter}
              </div>
            ))}
          </div>
          <div className='ms-auto d-flex align-items-center gap-2'>
            <button className='tag-list-data-div tag-list-data-delete'
              disabled={selectTagList.length > 0 ? false : true}
              onClick={() => {
                setTagDeletePopup(true)
                TagVideoDetails(selectTagList)
              }}>
              Delete <GoTrash />
            </button>
            <button className='tag-list-data-div tag-list-data-find'
              onClick={() => {
                setTagPopup(true)
                setFindTagFlag(true)
              }}>
              Find And Replace
              <MdFindReplace className='tag-list-edit' size={18} />
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='tag-listing'>
            {!loading ? (
              filteredTags.length > 0 ? (
                filteredTags.map((tag, index) => (
                  <div key={index} className={`tag-list ${selectTagList.includes(tag) ? 'selected' : ``}`}>
                    <div className='tag-list-name'
                      onClick={() => selectIds(tag)}
                    >
                      {tag}
                    </div>

                    <GoTrash className='tag-list-delete'
                      onClick={(e) => {
                        setTagDeletePopup(true)
                        setSelectTagList([tag])
                        TagVideoDetails([tag])
                      }}
                    />
                    <FaRegEdit className='tag-list-edit'
                      onClick={(e) => {
                        setTagPopup(true)
                        setUpdateTag(tag)
                        TagVideoDetails([tag])
                      }}
                    />
                  </div>
                ))
              ) : (
                <div className="noData d-flex flex-column w-100"
                  style={{ minHeight: 'unset' }}
                >
                  <div>
                    <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                  </div>
                  <div>No Data Available</div>
                </div>
              )) : (
              <div className="noData d-flex flex-column w-100"
                style={{ minHeight: 'unset' }}
              >
                <div>
                  <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {tagPopup &&
        <TagDirectoryEdit cancelPopup={cancelPopup} wrapperRef={wrapperRef} videoDetails={videoDetails}
          updateTag={updateTag} setUpdateTag={setUpdateTag} TagDirectoryList={TagDirectoryList} setTagPopup={setTagPopup}
          findTag={findTag} setFindTag={setFindTag} findTagFlag={findTagFlag} setFindTagFlag={setFindTagFlag}
          TagVideoDetails={TagVideoDetails} />
      }
      {tagDeletePopup &&
        <TagDirectoryDelete cancelPopup={cancelPopup} wrapperRef={wrapperRef} videoDetails={videoDetails}
          selectTag={selectTagList} TagDirectoryList={TagDirectoryList} setTagDeletePopup={setTagDeletePopup} />
      }
    </div>
  )
}

export default TagDirectory